<template>
  <div class="container">

    <div class="report-container" v-if="userProfile.userRole == 'admin' && userProfile.active == true">
      <input type="date" v-model="rDate">

      <p>{{ report }}</p>
      <button type="button" name="button" @click.prevent="fetchTrainingReport">TR</button>
    </div>

    <div class="report-container" v-if="userProfile.userRole == 'admin' && userProfile.active == true">
      <input type="date" v-model="sDate">

      <p>{{ userReport }}</p>
      <button type="button" name="button" @click.prevent="fetchUsers">UR</button>
    </div>

    <div class="no-access" v-if="userProfile.userRole !== 'admin'">
      <p>Page not found. Please navigate to a different page.</p>
    </div>

  </div>
</template>

<script>
const fb = require('./../firebase/firebase')
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      report: [],
      rDate: '',
      sDate: '',
      userReport: []
    }
  },
  computed: {
    userCompareDate () {
      return new Date(this.sDate)
    },
    reportDateStart () {
      return new Date(this.rDate)
    },
    ...mapState([ 'currentUser', 'userProfile' ])
  },
  methods: {
    fetchTrainingReport() {
      fb.trainingRegistrationsCollection.where('active','==',true).where('dateSubmitted', '>', this.reportDateStart).get().then((snap) => {
        snap.forEach((doc) => {
          // if (doc.data() && moment(doc.data().dateSubmitted.toDate()).format('YYYY-MM-DD') > this.reportDateStart) {
          if (doc.data()) {
            this.report.push({
              dateSubmitted: moment(doc.data().dateSubmitted.toDate()).format('YYYY-MM-DD'),
              program: doc.data().program,
              title: doc.data().title,
              sessionOne: doc.data().sessionOne,
              sessionTwo: doc.data().sessionTwo,
              sessionThree: doc.data().sessionThree,
              time: doc.data().time,
              location: doc.data().location,
              participantFirstName: doc.data().participantFirstName,
              participantLastName: doc.data().participantLastName,
              participantEmail: doc.data().participantEmail,
              participantPhone: doc.data().participantPhone,
              hasGuide: doc.data().hasGuide,
              registeredBy: doc.data().registeredBy,
              registrantFirstName: doc.data().registrantFirstName,
              registrantLastName: doc.data().registrantLastName,
              registrantEmail: doc.data().registrantEmail,
              registrantPhone: doc.data().registrantPhone,
              district: doc.data().district,
              building: doc.data().building,
              billingAddress: doc.data().billingAddress,
              billingCity: doc.data().billingCity,
              billingState: doc.data().billingState,
              billingZip: doc.data().billingZip,
              purchaseOrder: doc.data().purchaseOrder,
              unit: doc.data().unit
            })
          }
        })
      }).then (() => {
        console.log(this.report)
        console.log(this.reportDateStart)
      })
    },
    fetchUsers() {
      fb.usersCollection.where('signupDate', '>', this.userCompareDate).get().then((snap) => {
        snap.forEach((doc) => {
          if (doc.data() && doc.data().signupDate) {
            this.userReport.push({
              signupDate: moment(doc.data().signupDate.toDate()).format('YYYY-MM-DD'),
              active: doc.data().active,
              userId: doc.data().userId,
              userEmail: doc.data().userEmail,
              userFirstName: doc.data().userFirstName,
              userLastName: doc.data().userLastName,
              userRole: doc.data().userRole,
              districtName: doc.data().districtName,
              districtCity: doc.data().districtCity,
              districtState: doc.data().districtState
            })
          }
        })
      }).then (() => {
        console.log(this.userReport)
        console.log(this.userCompareDate)
      })
    },
    testFetch() {
      console.log(this.sDate)
    }
  }
}
</script>

<style lang="css" scoped>
.report-container {
  margin: 20px;
  border: 1px solid darkgray;
  border-radius: 5px;
  background-color: lightgray;
}
</style>